<template>
  <div
    class="bestdealer-publicity-wrapper"
    ref="bestdealerPublicity"
  >
    <div
      class="bestdealer-publicity"
      :style="{
        top: `${top}px`,
        transition: `top 0.2s ease-in-out`,
        maxHeight: `calc(100vh - ${top}px - 24px)`
      }"
    >
      <p class="bestdealer-publicity__features">
        features
      </p>
      <Icon
        class="bestdealer-publicity__logo"
        name="bestdealer-logo"
      />
      <p class="bestdealer-publicity__service">
        Customization Service
      </p>
      <p class="bestdealer-publicity__title">
        Bring You Brand to Life with Us.
      </p>
      <div
        class="bestdealer-publicity-section"
        v-for="(section, index) of sections"
        :key="index"
      >
        <img
          class="bestdealer-publicity-section__image"
          :src="section.image"
        >
        <p class="bestdealer-publicity-section__title">
          {{ section.title }}
        </p>
        <p class="bestdealer-publicity-section__description">
          {{ section.description }}
        </p>
        <a
          class="bestdealer-publicity-section__button"
          @click="showNewMessage()"
        >
          Get Started
        </a>
      </div>
    </div>

    <Transition name="bestdealer-publicity-servicer">
      <div
        v-if="show"
        class="bestdealer-publicity-servicer"
        :style="{
          left: `${left}px`
        }"
      >
        <div class="bestdealer-publicity-servicer__logo">
          <img
            src="@/assets/publicity/servicer.png"
            alt="Customer Service"
          >
          <p class="bestdealer-publicity-servicer__time">
            7*24
          </p>
        </div>
        <div>
          <p class="bestdealer-publicity-servicer__title">
            Hi~, Didn’t find it?
          </p>
          <p class="bestdealer-publicity-servicer__subtitle">
            Ask your Agent — FREE.
          </p>
        </div>
        <Button
          class="bestdealer-publicity-servicer__button"
          type="primary"
          @click="openIntercom"
        >
          Contact Us
        </Button>
        <img
          class="bestdealer-publicity-servicer__close"
          src="@/assets/publicity/close.svg"
          @click="show = false"
        >
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { Icon } from '../Icon'
import LogoCustomizationImage from '@/assets/publicity/logo-customization.png'
import BrandPackagingImage from '@/assets/publicity/brand-packaging.png'
import TailoredFulfillmentImage from '@/assets/publicity/tailored-fulfillment.png'
import { useIntercom } from '@/hooks/useIntercom'
import { useContactUs } from './useContactUs'
import { Button } from '../Button'
import { useElementBounding, useMutationObserver } from '@vueuse/core'

const { showNewMessage } = useIntercom()

const elRef = useTemplateRef('bestdealerPublicity')

const { left } = useElementBounding(elRef)

const { show } = useContactUs(elRef)

const sections = [
  {
    image: LogoCustomizationImage,
    title: 'Logo Customization Low MOQ',
    description: 'Start with low MOQ and get prototypes in 5–7 days.'
  }, {
    image: BrandPackagingImage,
    title: 'Brand Packaging',
    description: 'One-stop design & production (color boxes, logo printing).'
  }, {
    image: TailoredFulfillmentImage,
    title: 'Tailored Fulfillment',
    description: 'Customized logistics routes tailored to business needs.'
  }
]

const openIntercom = () => {
  show.value = false
  showNewMessage()
}

const gaps = reactive([0, 0])
const top = computed(() => {
  return gaps.reduce((a, b) => a + b) + 24
})

onMounted(() => {
  useMutationObserver(document.querySelector('.search-ceiling'), (mutations) => {
    const mutation = mutations[0]
    if (!mutation || mutation.type !== 'attributes' || mutation.attributeName !== 'class') return

    const { offsetHeight, className } = mutation.target
    if (className.includes('ceiling-up')) {
      gaps[0] = offsetHeight
    } else {
      gaps[0] = 0
    }
  }, {
    attributes: true,
    attributeFilter: ['class']
  })

  // 监听 Ai Deep Search 的变化
  const isAiSearch = !!document.querySelector('.ai-search')

  if (!isAiSearch) return

  useMutationObserver(document.body, () => {
    const aiDeepSearch = document.querySelector('.ai-search-banner__header')
    gaps[1] = aiDeepSearch ? aiDeepSearch.offsetHeight : 0
  }, {
    childList: true,
    subtree: true
  })
})
</script>

<style lang="less" scoped>
.bestdealer-publicity {
  position: sticky;
  top: 24px;
  padding: 16px 14px 16px 16px;
  width: 202px;
  border-radius: 12px;
  border: 1px solid #EBF1F5;
  background: #FFF;
  overflow-y: scroll;

  &__features {
    display: inline-block;
    padding: 2px 8px;
    color: #FFF;
    font-family: mon-700;
    font-size: 12px;
    font-style: italic;
    line-height: 18px;
    border-radius: 12px;
    background:#F55745;
  }

  &__logo {
    margin-top: 2px;
    margin-left: -2px;
    width: 144px;
    height: 30px;
  }

  &__service {
    font-family: mon-500;
    font-size: 10px;
    font-weight: 500;
    line-height: 14px;
  }

  &__title {
    margin-top: 24px;
    margin-bottom: 24px;
    font-family: mon-700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.32px;
  }

  &-section {
    width: 163px;

    + .bestdealer-publicity-section {
      margin-top: 32px;
    }

    &__image {
      height: 60px;
    }

    &__title {
      margin-top: 16px;
      font-family: mon-700;
      font-size: 13px;
      line-height: 18px;
    }

    &__description {
      margin-top: 8px;
      font-family: mon-500;
      font-size: 11px;
      line-height: 14px;
    }

    &__button {
      margin-top: 6px;
      display: inline-block;
      color: #007EB3;
      font-family: mon-600;
      font-size: 12px;
      line-height: 16px;
      text-decoration: underline;
      cursor: pointer;
    }
  }

  &-servicer {
    position: fixed;
    left: 48px;
    bottom: 24PX;
    width: 202px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px;
    border-radius: 12px;
    border: 1px solid #EBF1F5;
    background:
      linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 48px),
      linear-gradient(90deg, rgba(231, 173, 255, 0.48) 0%, rgba(194, 231, 247, 0.48) 50%, rgba(199, 235, 228, 0.48) 100%),
      white;
    box-shadow: 0 0 24px rgba(20, 20, 20, 0.12);

    &__logo {
      flex-shrink: 0;
      position: relative;
      width: 40px;
      height: 40px;

      > img {
        width: 100%;
        height: 100%;
      }
    }

    &__time {
      position: absolute;
      top: 0;
      right: -26px;
      padding: 0 6px;
      border-radius: 7px 7px 7px 0;
      background: #D3E1FD;
      color: #1B3E9C;
      font-family: mon-600;
      font-size: 10px;
      line-height: 14px;
    }

    &__title {
      color: #232323;
      font-family: mon-600;
      font-size: 14px;
      line-height: 18px;
    }

    &__subtitle {
      margin-top: 4px;
      color: #232323;
      font-family: mon-500;
      font-size: 12px;
      line-height: 16px;
    }

    &__button {
      width: 90px;
      height: 28px;
      background-color: #232323;
      font-size: 12px;
      line-height: 16px;
    }

    &__close {
      position: absolute;
      top: 8px;
      right: 8px;
      cursor: pointer;
    }
  }
}

.bestdealer-publicity-servicer-enter-active,
.bestdealer-publicity-servicer-leave-active {
  transition: all 0.3s ease;
}

.bestdealer-publicity-servicer-enter-from,
.bestdealer-publicity-servicer-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>
